import React, {useState} from 'react';
import {NavLink, Route, Routes} from 'react-router-dom';
import {MenuIcon, XIcon} from 'lucide-react';
import styles from './navigationMenu.module.scss';
import logo from '../../../../../assets/img/logos/TA-logo-horizontalni.png';
import {TestPage} from '../../../../layout/testovaci-stranka/testPage';
import {translate} from '../../../utils/localization-utils';
import Registration from '../../../../layout/registrace/registration';
import Home from '../../../../layout/home/home';

export default function NavigationMenu() {
	const [open, setOpen] = useState(false);

	const navLinks = [
		{
			to: '/',
			label: translate('menu.registration')
		}
	];

	const handleBackdropClick = () => setOpen(false);

	return (
		<>
			<header className="flex justify-between items-center px-6 py-4 bg-white">
				<div>
					<a href="https://tenderarena.cz/">
						<img src={logo} alt="Logo" className="h-5"/>
					</a>
				</div>
				<MenuIcon className="cursor-pointer block sm:hidden" onClick={() => setOpen(true)}/>
			</header>

			<nav className="hidden sm:flex gap-6 px-10 py-3 font-medium uppercase text-white bg-blue">
				{navLinks.map(({
					to,
					label
				}) => (
					<NavLink
						key={to}
						to={to}
						className={({isActive}) =>
							isActive ? styles.isActive : styles.customUnderline
						}
						end
					>
						{label}
					</NavLink>
				))}
			</nav>

			<div className="relative overflow-hidden">
				<div
					onClick={handleBackdropClick}
					className={`fixed inset-0 bg-black transition-opacity duration-300 z-10 ${
						open ? 'opacity-50 pointer-events-auto' : 'opacity-0 pointer-events-none'
					}`}
					aria-hidden={!open}
				>
				</div>
				<div
					className={`fixed top-0 right-0 h-full w-64 bg-blue text-white flex flex-col p-4 transition-transform duration-300 z-20 ${
						open ? 'translate-x-0' : 'translate-x-full'
					}`}
					role="dialog"
					aria-modal="true"
					aria-labelledby="mobile-menu-label"
				>
					<div className="flex justify-end mb-6">
						<XIcon className="text-white cursor-pointer" onClick={() => setOpen(false)}/>
					</div>

					{navLinks.map(({
						to,
						label
					}) => (
						<NavLink
							key={to}
							to={to}
							onClick={() => setOpen(false)}
							className={({isActive}) =>
								`py-2 text-lg uppercase ${isActive ? 'font-bold' : ''}`
							}
							end
						>
							{label}
						</NavLink>
					))}
				</div>
			</div>

			<div className="content w-full flex flex-1">
				<div className="w-full flex flex-col justify-center">
					<Routes>
						<Route path="/" element={<Registration/>}/>
						<Route path="/domu" element={<Home/>}/>
						<Route path="/testovaci-stranka" element={<TestPage/>}/>
					</Routes>
				</div>
			</div>
		</>
	);
}
